import type { INetwork } from 'relay-runtime';
import { getNetwork, getNoopNetwork } from '../src/getNetwork.ts';

export const network: INetwork = getNetwork();

export const noopNetwork: INetwork = getNoopNetwork();
